export const systemMain = ``;
